/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useState } from 'react';

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import { Input, InputGroup, InputRightElement, InputLeftElement } from '@mybridge/ui/input';
// import Dropdown from 'v4/components/common/Dropdown';
import { Button } from '@mybridge/ui/button';
import { deleteCompanyPage, getAllCompanyPages } from 'v4/store/actions/companyPages.actions';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Flex, Select, IconButton } from '@mybridge/ui';
import { useToast } from '@chakra-ui/react';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { EyeViewIcon, EyeViewFilledIcon } from '@mybridge/icons';

const DeactivatePageModal = (props) => {
  const { company, onClose, setModalType, showModal } = props;
  const toast = useToast();
  const [data, setData] = useState({ are_you_sure: "N" });
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: value }));
  };
  const { t } = useTranslator();
  const direction = useDirection();

  
  const getModalTitle = () => {
    switch(showModal) {
      case 'activate':
        return t('pages.activatePage') || 'Activate Page';
      case 'deactivate':
        return t('pages.deactivatePage') || 'Deactivate Page';
      case 'delete':
        return t('pages.deletePage') || 'Delete Page';
      default:
        return 'Page Action';
    }
  };

  const getModalText = () => {
    switch(showModal) {
      case 'activate':
        return `${t('pages.areYouSureActivate') || "Are you sure you want to activate page for"} ${company.name}?`;
      case 'deactivate':
        return `${t('pages.areYouSureDeactivate') || "Are you sure you want to deactivate page for"} ${company.name}?`;
      case 'delete':
        return `${t('pages.areYouSureDelete') || "Are you sure you want to delete page for"} ${company.name}?`;
      default:
        return `Are you sure you want to proceed with ${company.name}?`;
    }
  };

  const getButtonText = () => {
    switch(showModal) {
      case 'activate':
        return t('pages.activate') || 'Activate';
      case 'deactivate':
        return t('pages.deactivate') || 'Deactivate';
      case 'delete':
        return t('pages.delete') || 'Delete';
      default:
        return 'Submit';
    }
  };

  useEffect(() => {
    if (showModal) {
      setData({ are_you_sure: "N", why: "", password: "" });
    }
  }, [showModal]);

  
  const onSubmit = () => {
    dispatch(deleteCompanyPage({ 
      id: company.id, 
      actionType: showModal,
      reason: data.why || "This page is no longer required.",
      password: data.password 
     }))
      .then((res) => {
        if (res?.payload?.status_code === 403) {
          toast({
            title: 'Error',
            description: res.payload.detail,
            status: 'error',
            duration: 2000,
            isClosable: true,
            position: 'top',
          });
        } else {
          toast({
            title: t('toast.success') || "Success",
            description: res?.payload?.message || `${t('profileNetwork.page') || "Page"} ${showModal}d ${t('toast.successGeneric') || "successfully"}`,
            status: 'success',
            duration: 2000,
            isClosable: true,
            position: 'top',
          });
          dispatch(getAllCompanyPages());
        }
        setModalType('');
      });
  };

  return (
    <Modal isOpen={showModal} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{getModalTitle()}</ModalHeader>
        <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
        <ModalBody>
          <Flex justifyContent="space-between" alignItems="center" gap={2} mb="20px">
            <Text flex="1">
              {getModalText()}
            </Text>
            <Select
              defaultValue="N"
              value={data.are_you_sure}
              onChange={handleChange}
              width="80px"
              minW="80px"
              flexShrink={0}
              name="are_you_sure"
              sx={direction === 'rtl' ? {
                '&': {
                  textAlign: 'left',
                }
              } : {}}
            >
              <option value="Y">{t('myEvents.yes') || "Y"}</option>
              <option value="N">{t('myEvents.no') || "N"}</option>
            </Select>
          </Flex>
          {showModal !== "delete" && <><Box mb="20px">
            <Text>{`${t('pages.beforeYouProceed') || "Before you"} ${getButtonText().toLowerCase()} ${t('pages.canYouTellUsWhy') || "this page, can you tell us why?"}`}</Text>
            <Input
              placeholder={t('pages.enterReason') || "Enter the reason"}
              type='text'
              name="why"
              value={data.why}
              onChange={handleChange}
              autocomplete="off"
            />
          </Box>
          <Box>
            <Text>{t('pages.toContinue') || "To continue, please re-enter your password:"}</Text>
            <InputGroup>
              <Input
                type={showPassword ? 'text' : 'password'}
                placeholder={t('pages.password') || "Password"}
                name="password"
                value={data.password}
                onChange={handleChange}
              />
              {direction === 'rtl' ? (
                <InputLeftElement>
                  <IconButton
                    aria-label={
                      showPassword 
                        ? `${t('signingPage.hidePassword') || 'Hide password'}` 
                        : `${t('signingPage.showPassword') || 'Show password'}`
                    }
                    icon={showPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </InputLeftElement>
              ) : (
                <InputRightElement>
                  <IconButton
                    aria-label={
                      showPassword 
                        ? `${t('signingPage.hidePassword') || 'Hide password'}` 
                        : `${t('signingPage.showPassword') || 'Show password'}`
                    }
                    icon={showPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </InputRightElement>
              )}
            </InputGroup>
          </Box></>}
        </ModalBody>

        <ModalFooter>
          <Button borderRadius="30px" variant="btn-secondary">
            <Text onClick={onClose}>{t('buttons.cancel') || "Cancel"}</Text>
          </Button>
          <Button borderRadius="30px" isDisabled={data.are_you_sure === "N"} variant="primary" onClick={onSubmit}>
            {getButtonText()}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeactivatePageModal;
